import { createFileRoute, Navigate } from '@tanstack/react-router';
import { orgRoute } from '@/app/org-route';

export const Route = createFileRoute('/$orgId/admin/roles')({
  component: () => (
    <Navigate to={orgRoute('/settings')} search={{ section: 'roles' }} replace />
  ),
});
